export const FETCH_DATA = 'TV:FETCH_DATA';
export const FETCH_DATA_SUCCESS = 'TV:FETCH_DATA_SUCCESS';
export const FETCH_DATA_ERROR = 'TV:FETCH_DATA_ERROR';
